import React, {useEffect, useState, useRef} from 'react';
import LocationPicker from '../multiLocation/LocationPicker';
import ReactDOM from 'react-dom';
import {Link, useLocation, useHistory} from 'react-router-dom';
import {HomeIcon , SettingsIcon , Analytics , Calender, UserIcon ,AnalyticsIcon} from '../SvgIcon';
import ReceptionModeIcon from './ReceptionModeIcon';
import { ExitReceptionModeIcon } from '../../assets/SVG';
import '../../../src/assets/css/reception-mode.css';
import {hairdresserActions, userActions} from "../../_actions";
import siteSetting from "../../config/env";
import { AGENT_VISIBLE, PERMISSIONS_VISIBLE, MARKETING_HOME_VISIBLE } from '../../config/featureFlags';
import { useAccess, accessKnown, canMarket } from '../permissions/access';
import BaileyPetToggle from '../onboarding/bailey-intro/BaileyPetToggle';
import { isPublicPath } from './publicPaths';
import {connect} from "react-redux";
import { FaBoxOpen } from 'react-icons/fa';
import {paymentService} from "../../_services";
import NotificationPanel from '../notifications/NotificationPanel';
import agentService from '../../_services/agent.service';
import { useUnreadCount } from '../notifications/useUnreadCount';
import { useTodos } from '../notifications/todos';
import { useNotificationPoll } from '../notifications/useNotificationPoll';
import useWindowSize from '../new-service/useWindowSize';
import './sidenav-revamp.css';
import LocationBillingNag from '../multiLocation/LocationBillingNag';
import { getState as getReceptionState, refresh as refreshReception } from '../../_utils/receptionMode';

// Below this width the hamburger drawer is the navigation, so it owns
// notifications: the bell is hidden and an unread dot sits on the burger.
const MOBILE_NAV_MAX_WIDTH = 1099;

const HamburgerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

const ChevronDown = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// "Free trial · N days left" pill above the profile block. Only shows for a
// gated (requiresSubscription) account that is actively trialing AND has a
// period end — i.e. exactly the users the countdown means something for.
// Data comes from the subscriptionGate localStorage entry routes.js refreshes
// on every cold start, so no extra API call from the nav.
const TrialBadge = () => {
  let gate = null;
  try { gate = JSON.parse(localStorage.getItem('subscriptionGate') || 'null'); } catch (e) { /* no badge */ }
  if (!gate || gate.requiresSubscription !== true || gate.subscriptionStatus !== 'trialing' || !gate.subscriptionCurrentPeriodEnd) return null;
  const daysLeft = Math.max(0, Math.ceil((gate.subscriptionCurrentPeriodEnd * 1000 - Date.now()) / 86400000));
  return (
    <div className="sidenav-trial-badge" style={{
      margin: '0 12px 10px', padding: '7px 10px', borderRadius: 8,
      background: 'rgba(0,126,160,0.10)', color: '#007EA0',
      fontSize: 12, fontWeight: 600, textAlign: 'center',
      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
    }}>
      Free trial · {daysLeft} day{daysLeft === 1 ? '' : 's'} left
    </div>
  );
};

const toggleMenuClass = (e) => {
    // console.log("localStorage.getItem('menu')",localStorage.getItem('menu'))
    // if(localStorage.getItem('menu')){
    //     if(localStorage.getItem('menu')===1||localStorage.getItem('menu')==="1"){
    //         localStorage.setItem('menu',0);
    //     }else{
    //         localStorage.setItem('menu',1);
    //     }
    // }else{
    //     localStorage.setItem('menu',0);
    // }
    document.body.classList.toggle('nav_menu_open')
};
const removeMenuClass = () => {
    document.body.classList.remove('nav_menu_open')
    // document.body.classList.add('setting-temps-pages')
}

const salonId = localStorage.getItem('salonId') ;

// Active-state helpers — prefix matching so sub-routes still highlight the
// parent. A section's children are spelled either /section/child or
// /section-child in this app (/marketing-loyalty, /clients-nav, /voucher-v2),
// so both count as the same section. Matching the hyphen family rather than
// listing every sibling means a new tab highlights without touching this file.
const matchesPrefix = (pathname, prefixes) =>
    prefixes.some(p => pathname === p || pathname.startsWith(p + '/') || pathname.startsWith(p + '-'));

// The signed-in record saved at login (several historical shapes).
const storedHairdresser = () => {
    try {
        const u = JSON.parse(localStorage.getItem('user')) || null;
        return (u && (u.hairdresser || (u.userInfo && u.userInfo.hairdresser))) || null;
    } catch (e) { return null; }
};

const SideNav = (props) => {
    const location = useLocation();
    const routerHistory = useHistory();
    const history = props.history || routerHistory;
    const pathname = location.pathname;

    const isDiaryActive = matchesPrefix(pathname, ['/diary', '/newdiary1', '/event']);
    const isPosActive = pathname === '/pos';
    const isClientsActive = matchesPrefix(pathname, ['/clients']);
    const isFinanceActive = matchesPrefix(pathname, ['/transactions', '/finance', '/legacy-transactions', '/cashup']);
    const isCatalogueActive = matchesPrefix(pathname, [
        '/catalogue', '/new-services', '/edit-services', '/add-services', '/service-nav', '/services',
        '/product', '/stocktake', '/stock-transfers', '/forms', '/voucher', '/taxes',
    ]);
    const isStaffActive = matchesPrefix(pathname, ['/staff']);
    const isMarketingActive = matchesPrefix(pathname, ['/marketing', '/invoices']);
    const isAssistantActive = matchesPrefix(pathname, ['/assistant']);
    const isSettingsActive = matchesPrefix(pathname, ['/settings']);

    const [isCardAdded, setIsCardAdded] = useState(false);
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const profileAvatarRef = useRef(null);
    const [popoverPos, setPopoverPos] = useState({ top: 0, left: 0 });
    const navScrollRef = useRef(null);
    const [highlightStyle, setHighlightStyle] = useState({ opacity: 0 });
    const hasMeasuredRef = useRef(false);
    
    // This device's reception lock (src/_utils/receptionMode): the last known
    // state until the server answers, and locked stays locked on error.
    const initialSettings = (() => { const st = getReceptionState(); return { enabled: st.enabled, hiddenAreas: st.hiddenAreas }; })();
    
    const [receptionModeSettings, setReceptionModeSettings] = useState(initialSettings);

    // ── Notifications (mobile lives here instead of a header bell) ──
    const [notifPanelOpen, setNotifPanelOpen] = useState(false);
    const unreadCount = useUnreadCount();
    const { width: viewportWidth } = useWindowSize();
    const isMobileNav = viewportWidth <= MOBILE_NAV_MAX_WIDTH;
    // Same rule as the bell: the number is what needs you (To do); new
    // updates alone still light the dot.
    const todoCount = useTodos(isMobileNav && !isPublicPath(pathname)).count;
    const notifDisplayCount = todoCount > 9 ? '9+' : String(todoCount);

    // On mobile no bell is mounted to run the poll, so the nav does it
    useNotificationPoll(isMobileNav && !notifPanelOpen && !isPublicPath(pathname));

    // Unread dot on every hamburger, wherever the page header renders one
    useEffect(() => {
        const show = isMobileNav && (unreadCount > 0 || todoCount > 0) && !isPublicPath(pathname);
        document.body.classList.toggle('has-unread-notifications', show);
        return () => document.body.classList.remove('has-unread-notifications');
    }, [isMobileNav, unreadCount, todoCount, pathname]);

    const logout =() =>{
        let self = this;
        let _filterState = {
            allStaffStatus :true,
            workingStaffStatus:false,
            selectedFilterName:'all_staff',
            isFilterChange:false,
            isDefaultStaff:true,
        }
        props.dispatch(hairdresserActions.activeFilterStatus(_filterState));
        if (localStorage.getItem('accessToken')) {
            if(props.user) {
                let params = {
                    userId: props.user.userInfo.userId
                }
                props.dispatch(userActions.logout(params))
                    .then(function (response) {
                        localStorage.removeItem('persist:root');
                        localStorage.clear();
                        history.push("/");
                    })
            }else{
                localStorage.removeItem('persist:root');
                localStorage.clear();
                history.push("/");
            }
        }else{
            localStorage.removeItem('persist:root');
            localStorage.clear();
            history.push("/");
        }
    }

    // Sliding highlight: measure active link position and animate pill
    useEffect(() => {
        const updateHighlight = () => {
            if (!navScrollRef.current) return;
            const activeLink = navScrollRef.current.querySelector('a.active');
            if (activeLink) {
                const navRect = navScrollRef.current.getBoundingClientRect();
                const linkRect = activeLink.getBoundingClientRect();
                setHighlightStyle({
                    top: linkRect.top - navRect.top + navScrollRef.current.scrollTop,
                    height: linkRect.height,
                    opacity: 1,
                });
                hasMeasuredRef.current = true;
            } else {
                setHighlightStyle(prev => ({ ...prev, opacity: 0 }));
            }
        };
        // Small delay to let DOM settle after route change
        const timer = setTimeout(updateHighlight, 50);
        return () => clearTimeout(timer);
    }, [pathname]);

    useEffect( () => {
        if (localStorage.getItem('accessToken')) {
            checkpaymentMethodAdded();
            checkReceptionModeSettings();
        } else if (!isPublicPath(pathname)) {
            // Logged-out visitors on an authed page get sent home, but NOT on
            // public pages (booking links /book/:slug, /salon/:id, /login, gift
            // cards, etc.) — those must stay put. Without this guard a cold/direct
            // load of a public booking link bounced straight to the homepage.
            history.push('/')
        }

        // Add CSS classes immediately to prevent flickering
        document.body.classList.add('only---sidenav');
        document.body.classList.remove('menu_open');

        return () => {
            document.body.classList.remove('only---sidenav');
            document.body.classList.remove('menu_open')
        }
    }, [])

    // Retry fetching reception mode settings once user data loads
    const hairdresserIdFromProps = props.user && props.user.userInfo && props.user.userInfo.hairdresser && props.user.userInfo.hairdresser._id;
    useEffect(() => {
        if (hairdresserIdFromProps && localStorage.getItem('accessToken')) {
            checkReceptionModeSettings();
        }
    }, [hairdresserIdFromProps])

    // This useEffect is redundant since we're already initializing with cached settings
    // and checking for settings in the first useEffect
    // Removing this to prevent duplicate API calls and state updates

    // Store the reception mode settings in localStorage to prevent flickering
    useEffect(() => {
        if (receptionModeSettings.enabled) {
            localStorage.setItem('receptionModeSettings', JSON.stringify(receptionModeSettings));
        } else {
            localStorage.removeItem('receptionModeSettings');
        }
    }, [receptionModeSettings])

    // Listen for the custom event from ReceptionMode component
    useEffect(() => {
        const handleReceptionModeSettingsChanged = (event) => {
            // Directly update state with the event data instead of making another API call
            if (event.detail) {
                const { enabled, hiddenAreas } = event.detail;
                
                // Only update if we have valid data
                if (enabled !== undefined) {
                    const newSettings = {
                        enabled,
                        hiddenAreas: hiddenAreas || receptionModeSettings.hiddenAreas
                    };
                    
                    // Update state directly
                    setReceptionModeSettings(newSettings);
                    
                    // Update localStorage cache
                    if (enabled) {
                        localStorage.setItem('receptionModeSettings', JSON.stringify(newSettings));
                    } else {
                        localStorage.removeItem('receptionModeSettings');
                    }
                }
            }
        };

        window.addEventListener('receptionModeSettingsChanged', handleReceptionModeSettingsChanged);

        return () => {
            window.removeEventListener('receptionModeSettingsChanged', handleReceptionModeSettingsChanged);
        };
    }, [receptionModeSettings.hiddenAreas]); // Only depend on hiddenAreas to minimize re-renders

    const checkReceptionModeSettings = () => {
        // One store for the whole app; it fails CLOSED for a device last known
        // to be locked (this used to clear the cache and show everything on
        // any error).
        let isMounted = true;
        refreshReception().then((st) => {
            if (isMounted) setReceptionModeSettings({ enabled: st.enabled, hiddenAreas: st.hiddenAreas });
        });
        return () => { isMounted = false; };
    }

    const getSalon =() => {
        let self=this;
        let params = {}
        params.salonId = salonId;
        params.latitude =  siteSetting.default_latitude;
        params.longitude =  siteSetting.default_longitude;
        self.props.dispatch(hairdresserActions.getSalonProfile(params))
            .then(function (response) {

            })
    }

    const switchProfile=()=>{
        let self=this;
        let param={
            latitude: siteSetting.default_latitude,
            longitude:siteSetting.default_longitude,
            switchTo:0

        }
        //self.setState({dropdown:false})
        props.dispatch(hairdresserActions.hairdresserSwitchProfile(param))
            .then(function (response) {

                localStorage.setItem('defaultRedirectTo', 0);

                // This is switching to client side (switchTo: 0), so just redirect to home
                history.push('/');
            })
    }

    // Roles & permissions: each business entry follows a capability from the
    // server's resolved access, on every environment (self-employed keep their
    // own Finance / Catalogue / Profile / Marketing, as before). Someone nobody
    // gave a role resolves to their account type's default, which shows
    // exactly what checkReadOnly() always showed (owner or self-employed);
    // until /permissions/me lands we use checkReadOnly() itself.
    const { can: canDo } = useAccess();
    // Store first, then the record saved at login, so a store without the
    // user (it used to be emptied by a password change) never hides a
    // self-employed stylist's own pages.
    const navHd = props.user?.userInfo?.hairdresser || storedHairdresser();
    const seNav = navHd?.employmentTypeId === 2 && navHd?.isSalonOwner !== 1;
    const pending = () => !accessKnown() && checkReadOnly();
    const navShow = (cap) => seNav || canDo(cap) || pending();
    const navTeam = () => seNav || canDo('team') || (PERMISSIONS_VISIBLE && canDo('permissions')) || pending();
    const navMarketing = () => canMarket() || pending();
    const navBusiness = () => navShow('reports') || navShow('catalogue') || navTeam() || navMarketing();

    const checkReadOnly=()=>{
        const hairdresser = props.user?.userInfo?.hairdresser || storedHairdresser();
        // If role fields haven't populated yet, show tabs by default
        if(hairdresser?.isSalonOwner === undefined && hairdresser?.employmentTypeId === undefined){
            return true;
        }
        if(hairdresser?.isSalonOwner === 1 || hairdresser?.employmentTypeId === 2){
            return true;
        }
        return false;
    }

    // Bailey is for everyone it is switched on for, employed staff included.
    // The entry used to sit behind checkReadOnly() (owner or self-employed)
    // inside the business section, which staff don't get, so an employed
    // stylist could only reach /assistant by typing it (QA 2026-09-29). For
    // anyone else, ask the agent's own status, the check the page itself makes.
    const [baileyForStaff, setBaileyForStaff] = useState(false);
    useEffect(() => {
        if (!AGENT_VISIBLE || checkReadOnly()) return undefined;
        let alive = true;
        agentService.status()
            .then((res) => { if (alive) setBaileyForStaff(!!(res && res.data && res.data.responseData && res.data.responseData.available)); })
            .catch(() => {});
        return () => { alive = false; };
    }, [props.user && props.user.userInfo && props.user.userInfo._id]); // eslint-disable-line react-hooks/exhaustive-deps
    // Reception mode: a locked device whose Front desk role has no Bailey.
    const showBailey = AGENT_VISIBLE && (checkReadOnly() || baileyForStaff) && !(receptionModeSettings.enabled && receptionModeSettings.hiddenAreas && receptionModeSettings.hiddenAreas.bailey);
    const showChangePassword = !(receptionModeSettings.enabled && receptionModeSettings.hiddenAreas && (receptionModeSettings.hiddenAreas.accountPassword || receptionModeSettings.hiddenAreas.settings));
    const baileyItem = (
        <li>
            <Link to="/assistant" className={isAssistantActive ? "active" : ""} title="">
                <span className="menu_icon _bailey">
                    {/* Bailey's face, drawn as the other nav icons are: solid, in the menu's own colour */}
                    <svg viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"/><path fillRule="evenodd" d="M9 4h6a5 5 0 0 1 5 5v6a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5zm.5 5.6a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8zm5 0a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8z"/></svg>
                </span>
                <span className="sidenav_text">Bailey</span>
            </Link>
            <span className="sidenav-tooltip">Bailey</span>
        </li>
    );
    const baileyItemMobile = (
        <li>
            <Link onClick={removeMenuClass} to="/assistant" className={isAssistantActive ? "active" : ""} title="">
                <span className="menu_icon _bailey">
                    {/* Bailey's face, drawn as the other nav icons are: solid, in the menu's own colour */}
                    <svg viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"/><path fillRule="evenodd" d="M9 4h6a5 5 0 0 1 5 5v6a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5zm.5 5.6a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8zm5 0a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8z"/></svg>
                </span>
                <span className="sidenava_text">Bailey</span>
            </Link>
        </li>
    );

    const checkpaymentMethodAdded = () => {
        let params={};
        paymentService.checkCardAdded(params)
            .then(function(res){
                if(res.data.statusCode===1) {
                    //console.log("res", res.data.responseData?.result);
                    if(res.data.responseData?.result?.data.length>0){
                        //return true;
                        setIsCardAdded(true);
                    }else{
                        //return false;
                        setIsCardAdded(false);
                    }
                }else{
                    //return false;
                    setIsCardAdded(false);
                }
            })
    };
    // console.log("new_service_props111",props?.user?.userInfo?.hairdresser)

    // Hide SideNav on public/auth/marketing-site routes
    if (isPublicPath(pathname)) {
        return null;
    }

    return(
            <>
<div className="sidenav menu-show-desktop">
    <div className="sidenav-header">
        <span onClick={toggleMenuClass} className="menu_toogle_icon">
            <HamburgerIcon/>
        </span>
    </div>

    <nav className="sidenav-nav-scroll" ref={navScrollRef}>
        {/* Sliding highlight pill */}
        <div className="sidenav-highlight" style={{
            transform: `translateY(${highlightStyle.top || 0}px)`,
            height: highlightStyle.height || 0,
            opacity: highlightStyle.opacity || 0,
        }} />
        {/* Main section - always visible */}
        <ul className="sidenav-section">
            {(!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.diary) && (
                <li>
                    <Link to={`/diary/${salonId}`} className={isDiaryActive?"active":""} title="">
                        <span className="menu_icon">
                            <svg viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H7V2c0-.55-.45-1-1-1s-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 18H5c-.55 0-1-.45-1-1V8h16v12c0 .55-.45 1-1 1z"/></svg>
                        </span>
                        <span className="sidenav_text">Diary</span>
                    </Link>
                    <span className="sidenav-tooltip">Diary</span>
                </li>
            )}
            {(!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.checkout) && (
                <li>
                    <Link to="/pos" className={isPosActive?"active":""} title="">
                        <span className="menu_icon">
                            <svg viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg>
                        </span>
                        <span className="sidenav_text">Point of Sale</span>
                    </Link>
                    <span className="sidenav-tooltip">Point of Sale</span>
                </li>
            )}
            {(!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.clients) && (
                <li>
                    <Link to="/clients" className={isClientsActive?"active":""} title="">
                        <span className="menu_icon">
                            <svg viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v2c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-2c0-2.66-5.33-4-8-4z"/></svg>
                        </span>
                        <span className="sidenav_text">Clients</span>
                    </Link>
                    <span className="sidenav-tooltip">Clients</span>
                </li>
            )}
        </ul>

        {/* Business section - conditional on checkReadOnly() */}
        {navBusiness() && (
            <>
                <ul className="sidenav-section">
                    {navShow('reports') && (!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.transactions) && (
                        <li>
                            <Link to="/transactions" className={isFinanceActive?"active":""} title="">
                                <span className="menu_icon">
                                    <svg viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                                    </svg>
                                </span>
                                <span className="sidenav_text">Finance</span>
                            </Link>
                            <span className="sidenav-tooltip">Finance</span>
                        </li>
                    )}
                    {navShow('catalogue') && (!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.catalogue) && (
                        <li>
                            <Link to="/catalogue" className={isCatalogueActive?"active":""} title="">
                                <span className="menu_icon">
                                    <svg viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M4 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM7 8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1z"/></svg>
                                </span>
                                <span className="sidenav_text">Catalogue</span>
                            </Link>
                            <span className="sidenav-tooltip">Catalogue</span>
                        </li>
                    )}
                    {navTeam() && (!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.staff) && (() => {
                        const isSelfEmployed = seNav;
                        const staffLabel = isSelfEmployed ? 'Profile' : 'Team';
                        return (
                        <li>
                            <Link to="/staff" className={isStaffActive?"active":""} title="">
                                <span className="menu_icon">
                                    <svg viewBox="0 0 24 24"><g><rect fill="none" height="24" width="24"/><rect fill="none" height="24" width="24"/></g><g><g/><g><g><path d="M16.67,13.13C18.04,14.06,19,15.32,19,17v3h3c0.55,0,1-0.45,1-1v-2 C23,14.82,19.43,13.53,16.67,13.13z" fillRule="evenodd"/></g><g><circle cx="9" cy="8" fillRule="evenodd" r="4"/></g><g><path d="M15,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4c-0.47,0-0.91,0.1-1.33,0.24 C14.5,5.27,15,6.58,15,8s-0.5,2.73-1.33,3.76C14.09,11.9,14.53,12,15,12z" fillRule="evenodd"/></g><g><path d="M9,13c-2.67,0-8,1.34-8,4v2c0,0.55,0.45,1,1,1h14c0.55,0,1-0.45,1-1v-2 C17,14.34,11.67,13,9,13z" fillRule="evenodd"/></g></g></g></svg>
                                </span>
                                <span className="sidenav_text">{staffLabel}</span>
                            </Link>
                            <span className="sidenav-tooltip">{staffLabel}</span>
                        </li>
                        );
                    })()}
                    {navMarketing() && (!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.marketing) && (
                        <li>
                            <Link to={isCardAdded===true?(MARKETING_HOME_VISIBLE ? '/marketing-home' : '/marketing-campaigns'):"/marketing-setting"} className={isMarketingActive ? "active" : ""} title="">
                                <span className="menu_icon _markt">
                                    <svg width="31.455" height="31.512" viewBox="0 0 31.455 31.512">
                                        <path id="Icon_open-bullhorn" data-name="Icon open-bullhorn" d="M27,0V27a1.215,1.215,0,0,0,.405,0H31.05a.4.4,0,0,0,.405-.405V.45A.378.378,0,0,0,31.05.045H26.955ZM22.5,2.25,9.4,8.865A2.62,2.62,0,0,1,8.55,9H.4A.378.378,0,0,0,0,9.4V17.55a.378.378,0,0,0,.405.405H4.5l4.635,12.24a2.418,2.418,0,0,0,3.1,1.125,2.418,2.418,0,0,0,1.125-3.1L9.99,20.2a1.188,1.188,0,0,1,1.26-.99V19.08L22.5,24.7V2.2Z" transform="translate(0)" fill="#fff"/>
                                    </svg>
                                </span>
                                <span className="sidenav_text">Marketing</span>
                            </Link>
                            <span className="sidenav-tooltip">Marketing</span>
                        </li>
                    )}
                    {/* Bailey. Behind the same build flag as the page itself,
                        so the nav entry cannot point at a route that does not
                        exist off staging. Without this the assistant was only
                        reachable by typing the URL, which meant nobody would
                        ever find it. */}
                    {showBailey && baileyItem}
                </ul>
            </>
        )}

        {/* No business section (standard staff): Bailey gets its own. */}
        {!navBusiness() && showBailey && (
            <ul className="sidenav-section">{baileyItem}</ul>
        )}

        {/* Settings section */}
        <ul className="sidenav-section" style={{marginTop: navBusiness() ? 0 : 'auto'}}>
            {(!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.settings) && (
                <li>
                    <Link to="/settings" className={isSettingsActive ? "active" : ""} title="">
                        <span className="menu_icon">
                            <svg viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"/></svg>
                        </span>
                        <span className="sidenav_text">Settings</span>
                    </Link>
                    <span className="sidenav-tooltip">Settings</span>
                </li>
            )}
            <ReceptionModeIcon />
        </ul>
    </nav>

    {/* Multi-location: the switcher moved to the header of every page (LocationPicker). */}
    {/* Profile at bottom */}
    <TrialBadge />
    <LocationBillingNag />
    {/* Bailey the desk pet: show or hide him (after the welcome tour). */}
    <BaileyPetToggle />
    <div className={`sidenav-profile-bottom ${profileMenuOpen ? 'open' : ''}`} style={{position: 'relative'}}>
        <div className="sidenav-profile-toggle" onClick={(e) => { e.stopPropagation(); setProfileMenuOpen(!profileMenuOpen); }}>
            <img
                className="sidenav-profile-avatar"
                src={props?.user?.userInfo?.userImage?.circleImage || require('../../assets/images/Pixie.png')}
                alt="Profile"
            />
            <span className="sidenav-profile-name">{props?.user?.userInfo?.name || ''}</span>
            <span className="sidenav-profile-chevron">
                <ChevronDown />
            </span>
        </div>
        {profileMenuOpen && (
            <div className="sidenav-profile-menu">
                <div className="sidenav-profile-menu-item" onClick={() => { switchProfile(); setProfileMenuOpen(false); }}>
                    <span className="menu_icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M5.5 21c.83 0 1.5-.67 1.5-1.5V18h10v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V17c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v2.5c0 .83.67 1.5 1.5 1.5zM20 10h1c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1zM3 10h1c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1zm14 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"/></svg>
                    </span>
                    <span>Switch to client</span>
                </div>
                {showChangePassword && <div className="sidenav-profile-menu-item" onClick={() => { history.push('/settings/edit-password'); setProfileMenuOpen(false); }}>
                    <span className="menu_icon">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
                    </span>
                    <span>Change Password</span>
                </div>}
                <div className="sidenav-profile-menu-item sidenav-profile-menu-item--danger" onClick={() => { logout(); setProfileMenuOpen(false); }}>
                    <span className="menu_icon">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/></svg>
                    </span>
                    <span>Logout</span>
                </div>
            </div>
        )}
        {/* Collapsed-state popover tooltip */}
        <div className="sidenav-profile-tooltip">
            <div className="sidenav-profile-tooltip-header">{props?.user?.userInfo?.name || ''}</div>
            <div className="sidenav-profile-tooltip-item" onClick={() => { switchProfile(); }}>Switch to client</div>
            {showChangePassword && <div className="sidenav-profile-tooltip-item" onClick={() => { history.push('/settings/edit-password'); }}>Change Password</div>}
            <div className="sidenav-profile-tooltip-item sidenav-profile-tooltip-item--danger" onClick={() => { logout(); }}>Logout</div>
        </div>
    </div>
</div>
<div className="sidenava menu-show-mobile" onClick={removeMenuClass}>
    <div className="sidenava-meue sideMenu-bar" onClick={(e) => e.stopPropagation()}>
        <span onClick={toggleMenuClass} className="menu_toogle_icon">
            <HamburgerIcon/>
        </span>
        <button
            type="button"
            className="sidenav-notif-bell"
            aria-label={todoCount > 0 ? `Notifications, ${todoCount} to do` : unreadCount > 0 ? `Notifications, ${unreadCount} new` : 'Notifications'}
            onClick={() => { removeMenuClass(); setNotifPanelOpen(true); }}
        >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
            {todoCount > 0 && (
                <span className="sidenav-notif-count">{notifDisplayCount}</span>
            )}
            {todoCount === 0 && unreadCount > 0 && <span className="sidenav-notif-count is-dot" aria-hidden="true" />}
        </button>

        {/* Phones: switching location is always one tap away here too
            (renders nothing for a single-site salon). The menu closes so
            the slide-up sheet isn't underneath it. */}
        <div className="sidenav-mobile-location"><LocationPicker slot="drawer" onBeforeOpen={removeMenuClass} /></div>

        <nav className="sidenav-nav-scroll-mobile">
            {/* Main section */}
            <ul className="sidenav-section">
                {(!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.diary) && (
                    <li>
                        <Link onClick={removeMenuClass} to={`/diary/${salonId}`} className={isDiaryActive?"active":""} title="">
                            <span className="menu_icon">
                                <svg viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H7V2c0-.55-.45-1-1-1s-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 18H5c-.55 0-1-.45-1-1V8h16v12c0 .55-.45 1-1 1z"/></svg>
                            </span>
                            <span className="sidenava_text">Diary</span>
                        </Link>
                    </li>
                )}
                {(!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.checkout) && (
                    <li>
                        <Link onClick={removeMenuClass} to="/pos" className={isPosActive?"active":""} title="">
                            <span className="menu_icon">
                                <svg viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg>
                            </span>
                            <span className="sidenava_text">Point of Sale</span>
                        </Link>
                    </li>
                )}
                {(!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.clients) && (
                    <li>
                        <Link onClick={removeMenuClass} to="/clients-nav" className={isClientsActive?"active":""} title="">
                            <span className="menu_icon">
                                <svg viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v2c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-2c0-2.66-5.33-4-8-4z"/></svg>
                            </span>
                            <span className="sidenava_text">Clients</span>
                        </Link>
                    </li>
                )}
            </ul>

            {/* Business section */}
            {navBusiness() && (
                <>
                    <ul className="sidenav-section">
                        {navShow('reports') && (!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.transactions) && (
                            <li>
                                <Link onClick={removeMenuClass} to="/finance-nav" className={isFinanceActive?"active":""} title="">
                                    <span className="menu_icon">
                                        <svg viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                                        </svg>
                                    </span>
                                    <span className="sidenava_text">Finance</span>
                                </Link>
                            </li>
                        )}
                        {navShow('catalogue') && (!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.catalogue) && (
                            <li>
                                <Link onClick={removeMenuClass} to="/service-nav" className={isCatalogueActive?"active":""} title="">
                                    <span className="menu_icon">
                                        <svg viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M4 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM7 8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1z"/></svg>
                                    </span>
                                    <span className="sidenava_text">Catalogue</span>
                                </Link>
                            </li>
                        )}
                        {navTeam() && (!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.staff) && (() => {
                            const isSE = seNav;
                            return (
                            <li>
                                <Link onClick={removeMenuClass} to={isSE ? "/staff" : "/staff-nav"} className={isStaffActive?"active":""} title="">
                                    <span className="menu_icon">
                                        <svg viewBox="0 0 24 24"><g><rect fill="none" height="24" width="24"/><rect fill="none" height="24" width="24"/></g><g><g/><g><g><path d="M16.67,13.13C18.04,14.06,19,15.32,19,17v3h3c0.55,0,1-0.45,1-1v-2 C23,14.82,19.43,13.53,16.67,13.13z" fillRule="evenodd"/></g><g><circle cx="9" cy="8" fillRule="evenodd" r="4"/></g><g><path d="M15,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4c-0.47,0-0.91,0.1-1.33,0.24 C14.5,5.27,15,6.58,15,8s-0.5,2.73-1.33,3.76C14.09,11.9,14.53,12,15,12z" fillRule="evenodd"/></g><g><path d="M9,13c-2.67,0-8,1.34-8,4v2c0,0.55,0.45,1,1,1h14c0.55,0,1-0.45,1-1v-2 C17,14.34,11.67,13,9,13z" fillRule="evenodd"/></g></g></g></svg>
                                    </span>
                                    <span className="sidenava_text">{isSE ? 'Profile' : 'Team'}</span>
                                </Link>
                            </li>
                            );
                        })()}
                        {navMarketing() && (!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.marketing) && (
                            <li>
                                <Link onClick={removeMenuClass} to="/marketing-nav" className={isMarketingActive ? "active" : ""} title="">
                                    <span className="menu_icon _markt">
                                        <svg width="31.455" height="31.512" viewBox="0 0 31.455 31.512">
                                            <path id="Icon_open-bullhorn" data-name="Icon open-bullhorn" d="M27,0V27a1.215,1.215,0,0,0,.405,0H31.05a.4.4,0,0,0,.405-.405V.45A.378.378,0,0,0,31.05.045H26.955ZM22.5,2.25,9.4,8.865A2.62,2.62,0,0,1,8.55,9H.4A.378.378,0,0,0,0,9.4V17.55a.378.378,0,0,0,.405.405H4.5l4.635,12.24a2.418,2.418,0,0,0,3.1,1.125,2.418,2.418,0,0,0,1.125-3.1L9.99,20.2a1.188,1.188,0,0,1,1.26-.99V19.08L22.5,24.7V2.2Z" transform="translate(0)" fill="#fff"/>
                                        </svg>
                                    </span>
                                    <span className="sidenava_text">Marketing</span>
                                </Link>
                            </li>
                        )}
                        {/* Bailey. Mirrors the desktop entry above: this drawer is the
                            only nav below desktop width, so without it Bailey
                            could not be reached on a tablet or phone. */}
                        {showBailey && baileyItemMobile}
                    </ul>
                </>
            )}

            {!navBusiness() && showBailey && (
                <ul className="sidenav-section">{baileyItemMobile}</ul>
            )}

            {/* Settings section */}
            <ul className="sidenav-section">
                {(!receptionModeSettings.enabled || !receptionModeSettings.hiddenAreas.settings) && (
                    <li>
                        <Link onClick={removeMenuClass} to="/settings" className={isSettingsActive?"active":""} title="">
                            <span className="menu_icon">
                                <svg viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"/></svg>
                            </span>
                            <span className="sidenava_text">Settings</span>
                        </Link>
                    </li>
                )}
                <ReceptionModeIcon />
            </ul>
        </nav>

        {/* Profile at bottom */}
        <TrialBadge />
        <LocationBillingNag />
        <BaileyPetToggle />
        <div className={`sidenav-profile-bottom ${profileMenuOpen ? 'open' : ''}`}>
            <div className="sidenav-profile-toggle" onClick={(e) => { e.stopPropagation(); setProfileMenuOpen(!profileMenuOpen); }}>
                <img
                    className="sidenav-profile-avatar"
                    src={props?.user?.userInfo?.userImage?.circleImage || require('../../assets/images/client-plachoder.jpg')}
                    alt="Profile"
                />
                <span className="sidenav-profile-name">{props?.user?.userInfo?.name || ''}</span>
                <span className="sidenav-profile-chevron">
                    <ChevronDown />
                </span>
            </div>
            {profileMenuOpen && (
                <div className="sidenav-profile-menu">
                    <div className="sidenav-profile-menu-item" onClick={() => { switchProfile(); setProfileMenuOpen(false); }}>
                        <span className="menu_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M5.5 21c.83 0 1.5-.67 1.5-1.5V18h10v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V17c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v2.5c0 .83.67 1.5 1.5 1.5zM20 10h1c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1zM3 10h1c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1zm14 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"/></svg>
                        </span>
                        <span>Switch to client</span>
                    </div>
                    {showChangePassword && <div className="sidenav-profile-menu-item" onClick={() => { history.push('/settings/edit-password'); setProfileMenuOpen(false); }}>
                        <span className="menu_icon">
                            <svg viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
                        </span>
                        <span>Change Password</span>
                    </div>}
                    <div className="sidenav-profile-menu-item sidenav-profile-menu-item--danger" onClick={() => { logout(); setProfileMenuOpen(false); }}>
                        <span className="menu_icon">
                            <svg viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/></svg>
                        </span>
                        <span>Logout</span>
                    </div>
                </div>
            )}
        </div>
    </div>
</div>
{notifPanelOpen && (
    <NotificationPanel onClose={() => setNotifPanelOpen(false)} />
)}
          </>

)
}
//export default SideNav;
function mapStateToProps(state) {
    return {
        ...state
    };
}

export default connect(mapStateToProps)(SideNav);

